import React from 'react'
import { Radio, Stack, Typography } from '@mui/material'

interface SurveySelectRangeProps {
    selectedValue: number
}

const SurveySelectRange: React.FC<SurveySelectRangeProps> = ({ selectedValue }: SurveySelectRangeProps) => {
    if (selectedValue === 0) return null

    return (
        <Stack direction='row' alignItems='center'>
            Skvělé
            {[1, 2, 3, 4, 5].map((value, index) => {
                return (
                    <Stack key={index} alignItems='center' justifyContent='center'>
                        <Typography variant='body2'>{value}</Typography>
                        {selectedValue === value ? <Radio checked disabled /> : <Radio disabled />}
                    </Stack>
                )
            })}
            Velmi špatné
        </Stack>
    )
}

export default SurveySelectRange
